import React  from 'react';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import TenantWebsitesCardBasicInfo from './tenant-website-card-basic-info.component';


export const TenantWebsitesCardComponent = ({handleCloseProductModal,handleOpenProductModal,setPageSize,isModalOpen,isModalProductOpen,handleOpenModal,handleCloseModal,setPageData,
  additionButtons,onSelect,categoryColumnDefs,productsPaginationData,productColumnDefs,categories,products,categoriesPaginationData,handleFormSubmit, back, cardTemplate, cardValues, handleFormChange, deleteTenantwebCardItem,changeCardFile }: any) => {
  const tabItems=[
    {
        id:1,
        title:'Tenant Website Card Information',
        component:<TenantWebsitesCardBasicInfo 
        deleteTenantwebCardItem={deleteTenantwebCardItem}
        changeCardFile={changeCardFile}
        handleFormChange={handleFormChange}
        cardValues={cardValues}
        cardTemplate={cardTemplate}
        categoryColumnDefs={categoryColumnDefs}
        setPageData={setPageData}
        categoriesPaginationData={categoriesPaginationData}
          products={products}
          categories={categories}
          productColumnDefs={productColumnDefs}
          productsPaginationData={productsPaginationData}
          setPageSize={setPageSize}
          onSelect={onSelect}
          additionButtons={additionButtons}
          isModalOpen={isModalOpen}
          isModalProductOpen={isModalProductOpen}
          handleOpenModal ={handleOpenModal}
          handleCloseModal ={handleCloseModal}
          handleOpenProductModal ={handleOpenProductModal}
          handleCloseProductModal ={handleCloseProductModal}
        />,
        isVisible: true,
    },
   
    
  ]
  return (
    <div className="flex flex-col items-center w-full px-5 h-[520px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
            <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
       </div>
  )
}
export default TenantWebsitesCardComponent;
